<template>
    <div class="main"
         v-if="detail"
         :style="{background: detail.color || '#A26E71'}">
        <my-nav-bar title=""
                    :bordered="false"
                    :background="detail.color"
                    textColor="#FFF">
            <template slot="right">
                <span class="iconfont icon-fenxiang"></span>
            </template>
        </my-nav-bar>
        <div class="info">
            <div class="cover">
                <img :src="detail.thumb"
                     alt="">
            </div>
            <div class="right">
                <div class="top">
                    <span class="title">{{ detail.title }}</span>
                    <span class="status">{{ detail.is_status == 0 ? "连载中":"完结" }}</span>
                </div>
                <div class="author">
                    <!--                    <div class="auth-info">-->
                    <!--                        <div class="avatar">-->
                    <!--                            <img :src="detail.anchor[0].image" alt="">-->
                    <!--                        </div>-->
                    <!--                        <span class="name">-->
                    <!--                            {{this.detail.anchor.map(item=>item.nickname).join(" | ")}}-->
                    <!--                        </span>-->
                    <!--                    </div>-->
                    <span></span>
                    <div class="follow"
                         @click="openDownModal">+订阅</div>
                </div>
            </div>
        </div>
        <div class="describe"
             v-if="!isOpen">
            <div class="content">{{ detail.description }}</div>
            <div style="display: flex;justify-content: flex-end">
                <div class="read-more"
                     @click="changeOpen">
                    <span>查看更多</span>
                    <span class="iconfont icon-jiantouxia"></span>
                </div>
            </div>
        </div>
        <div v-else
             class="detail">
            <span class="sub-title">简介</span>
            <p>{{ detail.description }}</p>
            <span class="sub-title"
                  v-if="detail.anchor.length > 0">主播</span>
            <div class="anchor"
                 v-for="(item, index) in detail.anchor"
                 :key="index">
                <div class="left">
                    <img :src="item.image"
                         alt="">
                    <span>{{ item.nickname }}</span>
                </div>
                <div class="follow"
                     v-if="true"
                     @click="openDownModal">+关注</div>
                <div class="follow ed"
                     v-else>已关注</div>
            </div>
        </div>
        <div class="close-detail"
             @click="changeOpen"
             v-show="isOpen">
            <span>点击收起</span>
            <span class="iconfont icon-jiantoushang"></span>
        </div>
        <div class="list"
             v-show="!isOpen">
            <div class="tabs">
                <div :class="{'item': true, 'active': this.active == 0}"
                     @click="changeTab(0)">节目</div>
                <div :class="{'item': true, 'comment': true, 'active': this.active == 1}"
                     @click="changeTab(1)">评论<span class="num" v-if="detail.comments>0">{{ detail.comments }}</span></div>
                <div :class="{'item': true, 'active': this.active == 2}"
                     @click="changeTab(2)">找相似</div>
                <div style="flex: 1;text-align:right;position: relative;margin-right: 35px;">
                    <div class="lovenum">{{detail.love}}</div>
                    <span class="iconfont icon-thumb"
                    @click="openDownModal"
                          style="font-size:24px"></span>
                </div>
            </div>
            <div class="mescroll"
                 v-if="active == 0"
                 :style="{'height': height + 'px', 'overflow-y':'scroll'}">
                <div class="status-bar">
                    <div class="setting">
                        <div class="chapter"
                             @click="showChapter = true">
                            <span class="num"
                                  v-if="chapterList.length > 0">{{chapterList[curChapter].start || 1}}-{{ chapterList[curChapter].end || 1 }}</span>
                            <span class="iconfont icon-jiantouxia"
                                  v-if="!showChapter"></span>
                            <span class="iconfont icon-jiantoushang"
                                  v-else></span>
                        </div>
                    </div>
                    <div class="setting"
                         v-if="chapterList.length>0">
                        <!-- <div class="iconfont icon-download" style="margin-right: 16px" @click="openDownModal('请在APP内使用')"></div>
                        <div class="iconfont icon-sort" @click="openDownModal('请在APP内使用')"></div> -->
                        <!--                        <img @click="openDownModal('请在APP内使用')" style="margin-right: 16px" src="@/assets/img/Icons_download.png" alt="">-->
                        <img @click="openDownModal('请在APP内使用')"
                             src="@/assets/img/Icons_download1.png"
                             alt="">
                    </div>
                </div>
                <div class="videos">
                    <div class="item"
                         v-for="(item, index) in list"
                         :key="index"
                         @click="openDetail(item)">
                        <div class="cover">
                            <div class="play-icon">
                                <i class="iconfont icon-play"></i>
                            </div>
                            <img :src="item.video_image"
                                 alt="">
                        </div>
                        <div class="right">
                            <span :class="{'title': true, 'playing': item.id == audioInfo.id}">{{item.title}}</span>
                            <div class="video-info">
                                <!-- <div class="tag" v-else>试听</div> -->
                                <div class="views">
                                    <span class="iconfont icon-play-outlined"
                                          style="font-size: 12px"></span>
                                    {{item.views}}
                                </div>
                                <div class="comments">
                                    <span class="iconfont icon-message"></span>
                                    {{item.comments}}
                                </div>
                                <div class="time">
                                    <span class="iconfont icon-clock"></span>
                                    {{item.playtime}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="mescroll"
                 class="mescroll"
                 :style="{'height': height + 'px'}"
                 v-else>
                <template v-if="active == 1">
                    <CommentList :dataSource="comment"
                                 v-if="comment.length > 0" />
                    <div v-else
                         class="null-data">
                        <img src="@/assets/img/empty.png"
                             alt="">
                        <span>没有发现任何东西</span>
                    </div>
                </template>
                <template v-else>
                    <div class="videos big"
                         v-if="similars.length > 0">
                        <div class="item"
                             v-for="(item, index) in similars"
                             :key="index"
                             @click="openList(item)">
                            <div class="cover">
                                <div class="play-icon">
                                    <i class="iconfont icon-play"></i>
                                </div>
                                <img :src="item.video_image"
                                     alt="">
                            </div>
                            <div class="right">
                                <span class="title">{{item.title}}</span>
                                <div class="video-info">
                                    <!-- <div class="tag" v-else>试听</div> -->
                                    <div class="views">
                                        <text v-if="!(item.is_status == 0)"
                                              :style="{color: item.is_status == 1 ? '#2E8CFF' : '#FF4C67'}">{{item.is_status | switchStatus}}</text>
                                    </div>
                                    <div class="comments">
                                        <span class="iconfont icon-headset"></span>
                                        {{item.views}}
                                    </div>
                                    <div class="time">
                                        <span class="iconfont icon-clock"></span>
                                        {{item.sum}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else
                         class="null-data">
                        <img src="@/assets/img/empty.png"
                             alt="">
                        <span>没有发现任何东西</span>
                    </div>
                </template>
            </div>
            <van-popup v-model="showChapter"
                       position="bottom"
                       round>
                <div class="popup-body">
                    <div class="sub-title">选集</div>
                    <div class="chapter-list">
                        <div @click="changeChapter(index)"
                             :class="{'item': true, 'active': index == curChapter}"
                             v-for="(item, index) in chapterList"
                             :key="index">{{item.start}}-{{item.end}}集</div>
                    </div>
                    <div class="cancel"
                         @click="showChapter = false">取消</div>
                </div>
            </van-popup>
        </div>
        <!--        <g-player :audioType="VIRTUAL_VIDEO" ref="player"/>-->
    </div>
</template>

<script>
import { NavBar } from "vant";
import CommentList from "@/components/CommentList";
import Comment from "../../Patting/Comment";
import { CommentListApi, videoListApi, getSimilarApi } from "@/request/api";
import { VIRTUAL_VIDEO, AUDIO, PAUSE, PLAY } from "@/global/constant";
import { AudioInfo } from "@/global/audio";
import { mapState } from "vuex";

export default {
    data() {
        return {
            AUDIO,
            PLAY,
            PAUSE,
            active: 0,
            list: [],
            step: 20,
            comment: [],
            mescroll: null,
            height: 0,
            isOpen: false,
            showChapter: false,
            chapterList: [],
            curChapter: 0,
            id: 0,
            detail: {},
            filter: {
                page: 1,
                pcount: 999,
            },
            videoFilter: {
                page: 1,
                // 0-正序，1-倒序
                sort: 0,
            },
            nameStr: "",
            finished: false,
            // 音频是否为当前页
            similars: [],
        };
    },

    components: { Comment, NavBar, CommentList },
    filters: {
        switchStatus(status) {
            let str = "";
            switch (status) {
                case 1:
                    str = "连载中";
                    break;
                case 2:
                    str = "已完结";
            }
            return str;
        },
    },
    mounted() {
        // this.initScroll()
        this.height = document.body.clientHeight - 300;
        this.id = this.$route.query.id || 1419;
        // 需要等于这个才可以去赋值
        if (this.audioInfo.type == AUDIO) {
            this.pageAudioInfo = this.audioInfo;
        }
        this.getData();
    },
    watch: {
        curChapter() {
            this.setAudioList();
        },
        ["audioInfo.id"]() {
            if (this.audioInfo.type == AUDIO) {
                this.pageAudioInfo = this.audioInfo;
                this.setIsCurPagePlay();
            }
        },
    },
    computed: {
        ...mapState({
            audioInfo: (state) => state.audio.audioInfo,
            status: (state) => state.audio.status,
        }),
    },
    // created() {
    //     // 需要等于这个才可以去赋值
    //     if(this.audioInfo.type == VIRTUAL_VIDEO){
    //         this.pageAudioInfo = this.audioInfo
    //     }
    // },
    methods: {
        changeTab(index) {
            this.active = index;
            if (this.active != 0) {
                // 初始化mescroll
                if (!this.mescroll) this.initScroll();
                this.finished = false;
                this.filter.page = 1;
                if (this.active == 1) {
                    this.getComment();
                } else if (this.active == 2) {
                    this.getSimilar();
                }
            }
        },
        getSimilar() {
            getSimilarApi({
                cid: this.id,
                type: 2,
                ...this.filter,
            }).then((res) => {
                this.similars = res.data;
            });
        },
        openList(item) {
            let id = item.contentid || item.id;
            let url = window.location.href.replace(/id=[\d]*/, `id=${id}`);
            //重载页面
            window.location.href = url;
        },
        openDetail(item) {
            let url = `${
                window.location.href.split("/h5")[0]
            }/web/video/tvContent?album=true&id=${item.id}&cid=${
                item.contentid
            }&share=1`;
            window.location.href = url;
            // this.$router.push({
            //     path: '/video/detail',
            //     query: {
            //         cid: item.contentid,
            //         id: item.id
            //     }
            // })
        },
        getData() {
            videoListApi({ cid: this.id, ...this.videoFilter }).then((res) => {
                this.detail = res.data;
                this.$bus.$emit("linkDataUpdate", {
                    redirectPath: 20,
                    cid: this.id,
                });
                this.$bus.$emit("linkDataUpdateModel", {
                    redirectPath: 20,
                    cid: this.id,
                });
                // 分享配置
                this.globalInitWxShare(
                    this.detail.title,
                    this.detail.subtitle,
                    this.detail.thumb
                );
                this.initChapterList(this.detail.sum);
                this.list = this.detail.extend;
            });
        },
        setIsCurPagePlay() {
            // isCurPagePlay
            this.detail.extend.forEach((item) => {
                if (item.id == this.pageAudioInfo.id) this.isCurPagePlay = true;
            });
        },
        getComment() {
            CommentListApi({ ...this.filter, type: 0, cid: this.id }).then(
                (res) => {
                    if (this.filter.page == 1) {
                        this.comment = res.data;
                    } else {
                        this.comment = [...this.comment, ...res.data];
                    }
                    this.finished = res.data.length < this.filter.pcount;
                    if (this.finished) this.mescroll.showNoMore();
                }
            );
        },
        transTime(str) {
            let minutes = parseInt(str.split(":")[0]);
            let second = parseInt(str.split(":")[1]);
            return minutes * 60 + second;
        },
        playVideo(data) {
            if (data) {
                if (!this.checkIsVip(data)) {
                    return;
                }
                if (data.id == this.pageAudioInfo.id) return;
                // 停止正在播放的音频
                let tmp = JSON.parse(JSON.stringify(data));
                this.player.stop();
                this.pageAudioInfo = {
                    id: data.id,
                    name: data.title,
                    url: data.url,
                    poster: this.detail.thumb,
                    type: AUDIO,
                    audioId: this.id,
                    totalTime: this.transTime(data.playtime),
                };
                // this.player.play(this.pageAudioInfo)
                this.$router.push({
                    path: "/audio/detail",
                    query: {
                        pid: this.id,
                        id: data.id,
                    },
                });
            } else {
                // 没有传入data则为点击顶部按钮播放
                if (Object.keys(this.pageAudioInfo).length > 0) {
                    if (this.status == PLAY) {
                        // 已经有播放中的信息时暂停播放
                        this.player.pause();
                    } else {
                        this.player.resume();
                    }
                } else {
                    let tmp = this.list[0];
                    if (!this.checkIsVip(tmp)) {
                        return;
                    }
                    this.player.stop();
                    this.pageAudioInfo = {
                        id: tmp.id,
                        name: tmp.title,
                        url: tmp.url,
                        poster: this.detail.thumb,
                        type: AUDIO,
                        audioId: this.id,
                        totalTime: this.transTime(tmp.playtime),
                    };
                    // this.player.play(this.pageAudioInfo)
                    this.$router.push({
                        path: "/audio/detail",
                        query: {
                            pid: this.id,
                            id: tmp.id,
                        },
                    });
                }
            }
            this.isCurPagePlay = true;
        },
        checkIsVip(data) {
            // 会员专辑且需要付费
            if (data.is_audition != 1 && this.detail.is_vip == 1) {
                this.openDownModal("打开APP购买专辑");
                return false;
            } else {
                return true;
            }
        },
        // 初始化章节分页
        initChapterList(totalNum) {
            let cur = 0;
            let arr = [];
            while (totalNum > cur) {
                let obj = { start: 0, end: 0 };
                obj.start = cur + 1;
                if (totalNum < cur + this.step) {
                    cur = totalNum;
                } else {
                    cur += this.step;
                }
                obj.end = cur;
                arr.push(obj);
            }
            this.chapterList = arr;
            // this.setAudioList()
        },
        // 设置音频列表
        setAudioList() {
            this.videoFilter.page = this.curChapter + 1;
            this.showChapter = false;
            this.getData();
            // let data = this.chapterList[this.curChapter]
            // this.list = this.detail.extend.slice(data.start-1, data.end)
        },
        initScroll() {
            this.$nextTick(() => {
                this.mescroll = new MeScroll("mescroll", {
                    up: {
                        use: false,
                        callback: this.reachBottom,
                    },
                    down: {
                        use: false,
                    },
                });
            });
        },
        changeOpen() {
            this.isOpen = !this.isOpen;
        },
        changeChapter(index) {
            this.curChapter = index;
        },
        reachBottom() {
            if (this.finished || this.active == 0) return;
            this.filter.page++;
            this.getComment();
        },
    },
};
</script>

<style lang="less" scoped>
@baseColor: #a26e71;
@baseTextColor: #ff4c67;
.main {
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
}
.share {
    width: 24px;
    height: 24px;
}
.info {
    padding: 20px 16px;
    display: flex;
    align-items: center;
    height: 90px;
    .cover {
        width: 140px;
        height: 80px;
        border-radius: 6px;
        position: relative;
        overflow: hidden;
        margin-right: 12px;
        object-fit: cover;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .right {
        color: #fff;
        height: 90px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .top {
            display: flex;
            flex-direction: column;
            .title {
                font-size: 16px;
            }
            .status {
                margin-top: 4px;
                font-size: 12px;
                opacity: 0.5;
            }
        }
        .author {
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 12px;
            .auth-info {
                display: flex;
                align-items: center;
                .avatar {
                    min-width: 20px;
                    min-height: 20px;
                    max-width: 20px;
                    max-height: 20px;
                    border: 1px solid #fff;
                    box-sizing: border-box;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-right: 4px;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            .follow {
                padding: 6px 12px;
                border-radius: 50px;
                background: linear-gradient(to right, #ff7b9a, #ff1544);
                font-size: 14px;
                white-space: nowrap;
            }
        }
    }
}
.describe {
    margin: 12px 16px;
    padding: 12px;
    background-color: rgba(0, 0, 0, 0.1);
    color: #fff;
    font-size: 12px;
    border-radius: 4px;
    .read-more {
        padding: 2px 8px;
        background-color: rgba(255, 255, 255, 0.1);
        width: auto;
        font-size: 10px;
        border-radius: 50px;
        .iconfont {
            font-size: 10px;
        }
    }
    .content {
        color: #fff;
        display: -webkit-box;
        -webkit-box-orient: vertical; /*设置方向*/
        -webkit-line-clamp: 2; /*设置超过为省略号的行数*/
        overflow: hidden;
    }
}
.list {
    width: 100%;
    height: auto;
    background-color: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    border-radius: 16px 16px 0 0;
    padding: 0;
}
.tabs {
    margin: 10px 12px;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 4px;
    width: 100%;
    overflow-x: scroll;
    display: flex;
    align-items: center;
    .item {
        margin-right: 20px;
        position: relative;
        text-align: center;
        height: 35px;
        line-height: 35px;
        color: #646464;
        position: relative;
        .num {
            position: absolute;
            font-size: 10px;
            top: 0px;
            right: 0px;
            transform: translate(50%, -10%);
            background: #ff4c67;
            padding: 0 4px;
            line-height: 14px;
            display: inline-block;
            border-radius: 8px;
            color: #fff;
        }
        &::before {
            content: "";
            width: 24px;
            height: 4px;
            background-color: #fff;
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            border-radius: 50px;
        }
        &.active {
            font-size: 20px;
            color: @baseTextColor;
            &::before {
                background-color: @baseTextColor;
            }
            .num {
                right: -10px;
            }
        }
    }
}
.status-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    margin-bottom: 10px;
    color: #646464;
    .play-btn {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #222;
        padding: 6px 12px;
        background-color: #f8f8f8;
        max-width: 96px;
    }
    .setting {
        display: flex;
        align-items: center;
        .chapter {
            display: flex;
            align-items: center;
            .iconfont {
                font-size: 12px;
            }
            .num {
                white-space: nowrap;
                font-size: 13px;
                margin-right: 2px;
            }
        }
    }
    .icon-sort {
        margin-right: 16px;
    }
}
.play-info {
    width: 100%;
    box-sizing: border-box;
    padding: 8px 16px;
    background-color: rgba(#ff4c67, 0.1);
    color: @baseTextColor;
    font-size: 14px;
    display: flex;
    align-items: center;
    .play-circle {
        width: 24px;
        height: 24px;
        background-color: @baseTextColor;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        margin-right: 8px;
    }
}
.videos {
    .item {
        box-sizing: border-box;
        margin: 0 16px;
        padding: 16px 0;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        align-items: flex-start;
        .cover {
            width: 100px;
            height: 68px;
            margin-right: 12px;
            position: relative;
            border-radius: 5px;
            overflow: hidden;
            .play-icon {
                width: 28px;
                height: 28px;
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.4);
                display: flex;
                align-items: center;
                justify-content: center;
                color: #fff;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .right {
            display: flex;
            flex: 1;
            flex-direction: column;
            justify-content: space-between;
            height: 68px;
        }
        .title {
            font-size: 14px;
            line-height: 20px;
            color: #222;
        }
        .playing {
            color: @base-color;
        }
        .video-info {
            display: flex;
            .tag {
                padding: 2px 3px;
                border-radius: 2px;
                border: 1px solid @baseTextColor;
                color: @baseTextColor;
                font-size: 9px;
                margin-right: 10px;
                transform: scale(0.9);
                &.tag-vip {
                    border-color: #d0a85c;
                    color: #d0a85c;
                }
            }
        }
        .views,
        .comments,
        .time {
            color: #a7a7a7;
            font-size: 11px;
            display: flex;
            align-items: center;
            width: 50px;
            .iconfont {
            }
        }
    }
    &.big {
        .item {
            .cover {
                width: 150px;
                height: 80px;
                border-radius: 6px;
                overflow: hidden;
            }
        }
    }
}
.close-detail:extend(.flex-cen) {
    position: fixed;
    left: 50%;
    bottom: 50px;
    transform: translateX(-50%);
    font-size: 14px;
    color: #fff;
    padding: 8px 16px;
    border-radius: 50px;
    background-color: rgba(#222222, 0.5);
    .iconfont {
        font-size: 12px;
        margin-left: 2px;
    }
}
.detail {
    padding: 24px 16px;
    color: #fff;
    font-size: 13px;
    p {
        margin-bottom: 20px;
        line-height: 22px;
    }
    .sub-title {
        margin-bottom: 16px;
        display: block;
        font-size: 18px;
    }
    .anchor:extend(.flex-btw) {
        .left:extend(.flex-cen) {
            margin-bottom: 16px;
            img {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                margin-right: 12px;
            }
        }
        .follow:extend(.flex-cen) {
            width: 68px;
            height: 32px;
            color: #fff;
            border-radius: 50px;
            border: 1px solid #fff;
            &.ed {
                color: rgba(#fff, 0.5);
                border-color: rgba(#fff, 0.5);
            }
        }
    }
}
.popup-body {
    padding: 16px;
    box-sizing: border-box;
    position: relative;
    .sub-title {
        font-size: 16px;
        line-height: 22px;
    }
    .chapter-list {
        height: 250px;
        overflow-y: scroll;
        justify-content: space-between;
        display: grid;
        grid-template-columns: 106px 106px 106px;
        grid-row-gap: 12px;
        margin-top: 12px;
        .item:extend(.flex-cen) {
            width: 100%;
            border: 1px solid #cccccc;
            //height: 50px;
            max-height: 30px;
            padding: 6px 0;
            font-size: 12px;
            border-radius: 50px;
            transition: all linear 0.2s;
            &.active {
                color: #fff;
                background-color: #ff4c67;
                border: none;
            }
        }
    }
    .cancel {
        height: 44px;
        line-height: 44px;
        border: 1px solid #eeeeee;
        border-radius: 100px;
        text-align: center;
        margin-top: 20px;
    }
}
.null-data {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 100px;
    font-size: 14px;
    color: #222;
    img {
        width: 200px;
        object-fit: cover;
        margin-bottom: 10px;
    }
}
.lovenum {
    position: absolute;
    right: -10px;
    top: -5px;
    background: #ff4c67;
    padding: 0 5px;
    border-radius: 20px;
    color: #fff;
    font-size: 10px;
    transform: scale(0.8);
}
</style>
